<template>
  <div id="app1">
    <div style="line-height: 30px;font-weight: 900;background: linear-gradient(180deg, #0e71ff, #fff);">49.me 【开奖直播快人3秒】</div>
    <div v-if="show">
      <iframe style="margin: 0;width: 100%;height: 266px;border:none" src="https://77.2135a.cc:1888/video"></iframe>
    </div>
    <div v-if="!show" style="padding: 10px 0;">
      <img style="width: 100%;max-width:700px;height:250px;margin: auto;" src="../public/resource/assets/back/49kj.png" />
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'IndexView',
  components: {
    // HelloWorld
  },
  data(){
    return{
      show:false,
      act:0,
      kjdata:[],
      kjyears:[],
      kjhis:[],
      hisi:'',
      hisyear:new Date().getFullYear(),
      ballnum:[],
      ballnum_bak : ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49'],
      kjnum:[],
      kjnumpositions:[
        {"x":38,"y":63},{"x":32.9,"y":60.2},{"x":28.4,"y":56.4},{"x":24.5,"y":51.5},{"x":21.6,"y":45.5},{"x":20,"y":38.8},{"x":56.5,"y":63}
      ],
      para:[],
      para2:[],
      isRoll:[false,false,false,false,false,false],
      scale:document.body.clientWidth>=900?1:document.body.clientWidth/900,
      ishistory:false,
      animationTime:1500,
      timearr:[],
      isvideo:false,
      nowkjnumi:0
    }
  },
  created(){
    let h = new Date().getHours();
    let m = new Date().getMinutes()
    if(h==21&&m<40){
      this.show=true;
    }
  }
}
</script>
